<template>
  <v-item-group
    mandatory
    class="mt-3 mx-2"
    style="width: 100%"
  >
    <v-row
      class="mx-0"
      style="overflow-y: scroll;overflow-x: hidden;border-bottom: 0px solid #e3e3e3"
      :style="{height : (!noscroll ? '470px' : null)}"
    >
      <v-col
        v-for="(item, i) in items"
        :key="i"
        cols="12"
        class="pa-0 mb-3"
      >
        <v-card
          flat
          width="100%"
          class="d-flex my-0 px-0 pa-2"
        >
          <v-col
            class="pa-0"
            style="max-width: 120px !important;"
          >
            <v-avatar
              tile
              width="110"
              height="110"
              style="border-radius: 5px !important;"
            >
              <img
                :src="(item.avatar ? item.avatar.link : '/img/noImage.png')"
                alt="John"
              >
            </v-avatar>
          </v-col>
          <v-col
            class="pa-0"
          >
            <div
              class="pe-2"
              style="font-size: 16px;line-height: 1.5;"
            >
              {{ item.name }}
            </div>
          </v-col>
        </v-card>
        <v-card
          class="d-flex my-0 mx-0 mb-3"
          flat
        >
          <v-card
            class="pa-2 pt-0 px-0 d-flex my-0"
            width="50%"
            flat
          >
            <v-btn
              small
              color="green"
              height="40"
              outlined
              style="padding: 0px !important;min-width: 40px !important;"
              @click="addCount(item)"
            >
              <v-icon
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-text-field
              v-model="item.count"
              height="40"
              dense
              solo
              hide-details
              flat
              class="dense mx-1"
              :rules="[v => !!v || $t('is-required')]"
              :suffix="(item.unit ? item.unit.fame : '')"
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('count')"
              type="number"
            />
            <v-btn
              small
              outlined
              color="pink"
              height="40"
              style="padding: 0px !important;min-width: 40px !important;padding-top: 2px"
              class="me-1"
              @click="minusCount(item)"
            >
              <v-icon
                dark
              >
                {{ (item.count == 1 ? 'mdi-trash-can-outline' : 'mdi-minus') }}
              </v-icon>
            </v-btn>
          </v-card>
          <v-card
            class="pa-2 pt-0 my-0 pt-1 py-0"
            flat
            width="50%"
          >
            <p class="text-left text mb-0">
              {{ $t('fee') }} : <span style="font-size: 14px">{{ $numberFormat(item.price) }} </span>
            </p>
            <p class="text-left mb-0">
              {{ $t('sum') }} : <span style="font-size: 16px;font-weight: bold;">{{ $numberFormat(item.price*item.count) }} </span>{{ $store.state.currency.symbol }}
            </p>
          </v-card>
        </v-card>
        <v-divider v-show="items.length > i + 1" />
      </v-col>
    </v-row>
  </v-item-group>
</template>

<script>
  export default {
    name: 'MProductSeleted',
    props: ['selectedItems', 'noscroll'],
    data () {
      return {
        items: [],
      }
    },
    mounted () {
      this.items = this.selectedItems
    },
    watch: {
      selectedItems () {
        this.items = this.selectedItems
      },
      // items: {
      //   handler () {
      //   },
      //   deep: true,
      // },
    },
    methods: {
      addCount (item) {
        item.count++
        this.setItem(item)
      },
      setItem (item) {
        var index = this.items.findIndex(x => x.id === item.id)
        if (index < 0) {
          item.product = {
            id: item.id,
            name: item.name,
            type: item.type,
            unit_id: item.unit_id,
            unit: item.unit,
          }
          this.items.push(item)
        } else {
          this.items[index].count = item.count
        }
        this.$emit('input', this.items)
      },
      removeItem (item) {
        var index = this.items.findIndex(x => x.id === item.id)
        if (index > -1) {
          this.items.splice(index, 1)
        }
        this.$emit('input', this.items)
      },
      minusCount (item) {
        if (item.count > 0) {
          item.count--
          this.setItem(item)
          if (item.count === 0) {
            this.removeItem(item)
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
